import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product } from 'src/app/core/models/entities';
import { ODataService } from 'src/app/core/services/odata.service';
import { environment } from '@environments/environment';

@Injectable({ providedIn: null })
export class ProductService extends ODataService<Product> {
  private readonly baseUrl = `${environment.apiUrl}/v1/organization/administrative/organization`;

  constructor() {
    super(inject(HttpClient), `${environment.apiUrl}/v1/organization/administrative/organization`);

    this.state = {
      skip: 0,
      take: 100,
      sort: [{ field: 'name', dir: 'asc' }],
      filter: {
        logic: 'and',
        filters: [],
      },
    };
  }

  setOrganizationId(organizationId: number): void {
    this.url = `${this.baseUrl}(${organizationId})/list_products/`;
  }
}
